import validationService from '../services/validationService';

const UPDATE_FORM = 'tuko-kalenteri/forms/UPDATE_FORM';

export default function forms(state = {}, action) {
  const newForm = action.form;

  switch (action.type) {
    case UPDATE_FORM:
      newForm.errors = validationService(action.form);
      return Object.assign({}, state, { form: newForm });
    default:
      return state;
  }
}

export function updateForm(form) {
  return { type: UPDATE_FORM, form };
}



// WEBPACK FOOTER //
// ./src/reducers/forms.js